import Link from 'next/link';
import styles from './styles.module.scss';

const ImpactTrigger = () => {
  return (
    <div className={styles.impactTrigger}>
      <h5>Стань амбассадором <span>DonorSearch</span></h5>
      <p>Твой опыт в донорстве бесценен, и мы приглашаем тебя поделиться им, став наставником для новичков. Твоя помощь позволит нашему сообществу расти и развиваться.</p>
      <p>Привлекай друзей в DonorSearch, поддерживай их на пути донора и отслеживай свой вклад в донорство.</p>

      <Link href={'/profile/impact'}>Пригласить друзей</Link>
    </div>
  );
};

export default ImpactTrigger;